import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ListItem} from '../../classes/list-item.class';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';
import {DinaUppgifterService} from '../../../services/dina-uppgifter.service';

@Component({
  selector: 'app-form-currency',
  templateUrl: './form-currency.component.html',
  styleUrls: ['./form-currency.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormCurrencyComponent implements OnInit, OnDestroy {

  @Input() id = '';
  @Input() label = '';
  @Input() screenReaderText = '';
  @Input() listItems: ListItem[] = [];
  @Input() form: UntypedFormGroup;
  @Input() isSubmitted = false;
  @Input() errorMessage = '';

  private subscriptions: Subscription[] = [];

  get currencyControl(): AbstractControl {
    return this.form.get('valuta');
  }

  get amountControl(): AbstractControl {
    return this.form.get('belopp');
  }

  constructor(
    private readonly dittUnderlagService: DinaUppgifterService
  ) { }

  ngOnInit(): void {
    this.initValues();
    // Vet inte hur man trigga OnInitEventet utan en subscribe. Detta är en provisorisk lösning
    this.subscriptions.push(
      this.dittUnderlagService.edit$.subscribe(() => {
        this.initValues();
      })
    );
  }

  initValues(): void {
    this.amountControl.disable();

    if (this.currencyControl.value || this.amountControl.value) {
      this.amountControl.enable();
    }
  }

  onSelectChange(): void {
    if (this.currencyControl.value !== '-1') {
      this.amountControl.enable();
    } else {
      this.amountControl.setValue(null);
      this.amountControl.disable();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    });
    this.subscriptions = [];
  }
}
